module.exports = __webpack_public_path__ + "img/rodriguezhnos-logo.c30e8581.png";